// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xH_Z","footer":"styles_footer__2MwYb"};